import React from 'react';
import { Table, Badge } from 'react-bootstrap';

const ProjectStatusTable = ({ projects }) => {
  return (
    <Table bordered hover size="sm">
      <thead>
        <tr>
          <th>Tenant</th>
          <th>Project</th>
          <th>Stage</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        {projects.map(p => (
          <tr key={p.project_id}>
            <td>{p.tenant_name} ({p.tenant_slug})</td>
            <td>{p.project_name}</td>
            <td>
              <Badge bg="info">
                {p.current_stage.replace('_', ' ')}
              </Badge>
            </td>
            <td>{p.status}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default ProjectStatusTable;
